import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  TextField,
  Button,
  DialogActions,
  FormControlLabel,
  Switch,
  DialogTitle,
  DialogContent,
  Dialog,
} from "@mui/material";
import ApiService from "../../Api/ApiController";
import Swal from "sweetalert2";
import "./orderlist.css";
import Select from "react-select";

export default function OrderList() {
  const [orderList, setOrderList] = useState([]);
  const [users, setUsers] = useState([]);
  const [pagination, setPagination] = useState({});
  const [page,setpage] = useState(1);
  const [selectedTab,setSelectedTab] = useState("profit");
  const [filters, setFilters] = useState({
    status: "",
    user_id: "",
    start_date: "",
    end_date: "",
  });
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [editFormData, setEditFormData] = useState({
    quantity: "",
    entry_price: "",
    exit_price: "",
    order_status: "",
    amount: "",
    type: "",
    order_type:"",
    stock_name:"",
  });
  const handlePageChange=(page)=>{
    setFilters({...filters ,page})
    setpage(page)
  }
  // Fetch orders with filters
  const getorders = () => {
   
    ApiService.orderList(filters)
      .then((response) => {
        if (response.data.status === true) {
          setOrderList(response.data.data.data);
          setPagination(response.data.data.paginator);
        } else {
          console.log(response.data);
        }
      })
      .catch((error) => console.log(error));
  };

  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    setFilters({ ...filters, [name]: value });
  };

  // Delete order functionality
  const deleteorder = (orderId) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to delete this order?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
      customClass: {
        confirmButton: "custom-confirm-button",
        cancelButton: "custom-cancel-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        ApiService.deleteOrder({
          order_id: orderId,
        })
          .then((response) => {
            if (response.data.status === true) {
              Swal.fire({
                icon: "success",
                title: response.data.message,
              });
              getorders();
            } else {
              Swal.fire({
                icon: "error",
                title: response.data.message,
              });
            }
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: error.response.data.message,
            });
          });
      }
    });
  };

  const updateOrderstatus = (orderId, newStatus) => {
    ApiService.updateOrderstatus({
      order_id: orderId,
      status: newStatus,
    })
      .then((response) => {
        if (response.data.status === true) {
          Swal.fire({
            icon: "success",
            title: response.data.message,
          });
          getorders();
        } else {
          Swal.fire({
            icon: "error",
            title: response.daata.message,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: error.response.daata.message,
        });
      });
  };

  // Fetch users for the user_id dropdown
  const getUsers = () => {
    ApiService.userlistForcreateOrder()
      .then((response) => {
        if (response.data.status === true) {
          const formattedOption = response.data.data.map((user) => ({
            label: user.name,
            value: user._id,
          }));
          setUsers(formattedOption);
        } else {
          console.log(response.data);
        }
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    getorders();
    getUsers();
  }, [page]);

  const statusOptions = [
    { value: "", label: "All" },
    { value: "open", label: "Open" },
    { value: "closed", label: "Closed" },
    { value: "rejected", label: "Rejected" },
    { value: "holding", label: "Holding" },
    { value: "exited", label: "Execute" },
  ];

  const openEditDialog = (order) => {
    setSelectedOrder(order);
    setEditFormData({
      quantity: order.quantity,
      entry_price: order.entry_price,
      exit_price: order.exit_price,
      order_status: order.order_status,
      amount: order.amount,
      notification_send: order.notification_send || false,
      user_id:order.user_id?._id,
      stock_name:order.stock_name
    });
    setSelectedTab(order.order_type)
    setEditDialogOpen(true);
  };

  const closeEditDialog = () => {
    setEditDialogOpen(false);
    setSelectedOrder(null);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData({ ...editFormData, [name]: value });
  };

  const handleEditSave = () => {
    if (!selectedOrder) return;
    const updatedData = {
      ...editFormData,
      amount: parseFloat(editFormData.amount),
      order_type: selectedTab
    };
    ApiService.updateOrder(selectedOrder._id, updatedData)
      .then((response) => {
        if (response.data.status) {
          Swal.fire({ icon: "success", title: "Order updated!" });
          getorders();
          closeEditDialog();
        } else {
          Swal.fire({ icon: "error", title: response.data.message });
        }
      })
      .catch((err) => Swal.fire({ icon: "error", title: err.message }));
  };
   const handleTabChange = (tab)=>{
         setSelectedTab(tab);
    setEditFormData({
      ...editFormData,
      order_type : tab ? tab : 'profit'
    })
   }
  return (
    <div>
      <Box sx={{ padding: "16px" }}>
        <Typography variant="h4" gutterBottom>
          Order List
        </Typography>

        {/* Filter Section */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap", // Allow wrapping of items
            gap: "16px",
            marginBottom: "16px",
            alignItems: "center",
            justifyContent: "flex-start", // Align items on larger screens
            "@media (max-width: 600px)": {
              flexDirection: "column", // Stack items vertically on small screens
              alignItems: "stretch", // Ensure full width for inputs
            },
          }}
        >
          {/* Status Filter */}
          <Select
            options={statusOptions}
            name="status"
            value={
              statusOptions.find((option) => option.value === filters.status) ||
              ""
            }
            onChange={(selectedOption) =>
              setFilters({ ...filters, status: selectedOption.value })
            }
            placeholder="Select Status"
            isSearchable
            styles={{
              control: (provided) => ({
                ...provided,
                width: "200px",
                minHeight: "40px",
                "@media (max-width: 600px)": { width: "100%" },
              }),
              menu: (provided) => ({
                ...provided,
                zIndex: 9999, // Ensure the dropdown is above other elements
              }),
              menuPortal: (provided) => ({
                ...provided,
                zIndex: 9999, // For portals, ensure dropdown appears above everything
              }),
            }}
            menuPortalTarget={document.body} // Attach the dropdown menu to the body for higher z-index
          />

          {/* User ID Filter */}
          <Select
            options={users}
            name="user_id"
            value={users.find((option) => option.value === filters.user_id)}
            onChange={(selectedOption) =>
              setFilters({ ...filters, user_id: selectedOption.value })
            }
            placeholder="Select Client"
            isSearchable
            styles={{
              control: (provided) => ({
                ...provided,
                width: "200px",
                minHeight: "40px",
                "@media (max-width: 600px)": { width: "100%" }, // Full width on small screens
              }),
              menu: (provided) => ({
                ...provided,
                zIndex: 9999,
              }),
              menuPortal: (provided) => ({
                ...provided,
                zIndex: 9999,
              }),
            }}
            menuPortalTarget={document.body}
          />

          {/* Start Date Filter */}
          <TextField
            label="Start Date"
            name="start_date"
            type="date"
            value={filters.start_date}
            onChange={handleFilterChange}
            size="small"
            InputLabelProps={{ shrink: true }}
            sx={{
              width: "200px",
              "@media (max-width: 600px)": { width: "100%" }, // Full width on small screens
            }}
          />

          {/* End Date Filter */}
          <TextField
            label="End Date"
            name="end_date"
            type="date"
            value={filters.end_date}
            onChange={handleFilterChange}
            size="small"
            InputLabelProps={{ shrink: true }}
            sx={{
              width: "200px",
              "@media (max-width: 600px)": { width: "100%" }, // Full width on small screens
            }}
          />

          {/* Search Button */}
          <Button
            variant="contained"
            color="primary"
            onClick={getorders}
            sx={{
              width: "120px",
              "@media (max-width: 600px)": { width: "100%" }, // Full width on small screens
            }}
          >
            Search
          </Button>
        </Box>

        {/* Orders Table */}
        <div component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>S.No.</TableCell>
                <TableCell>Stock Name</TableCell>
                <TableCell>User Name</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Entry Price</TableCell>
                <TableCell>Exit Price</TableCell>
                <TableCell>Profit/Loss</TableCell>
                <TableCell>Order Status</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {orderList.map((order, index) => (
                <TableRow key={order._id}>
                  <TableCell data-label="S.No.">{index + 1}</TableCell>
                  <TableCell data-label="Stock Name">
                    {order.stock_name}
                  </TableCell>
                  <TableCell data-label="User Name">
                    {order.user_id.name}
                  </TableCell>
                  <TableCell data-label="Quantity">{order.quantity}</TableCell>
                  <TableCell data-label="Entry Price">
                    {order.entry_price}
                  </TableCell>
                  <TableCell data-label="Exit Price">
                    {order.exit_price}
                  </TableCell>
                  <TableCell
                    data-label="Profit/Loss"
                    sx={{
                      color: order.order_type === "profit" ? "green" : "red",
                    }}
                  >
                    {order.amount}
                  </TableCell>
                  <TableCell data-label="Order Status">
                    <Select
                      options={statusOptions.filter(
                        (option) => option.value !== ""
                      )}
                      value={statusOptions.find(
                        (option) => option.value === order.order_status
                      )}
                      onChange={(selectedOption) =>
                        updateOrderstatus(order._id, selectedOption.value)
                      }
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          width: "120px",
                          minHeight: "30px",
                        }),
                        menu: (provided) => ({
                          ...provided,
                          width: "120px",
                        }),
                      }}
                    />
                  </TableCell>
                  <TableCell data-label="Action">
                    
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => openEditDialog(order)}
                  >
                    Edit
                  </Button>
                    <button
                      className="table_btn"
                      onClick={() => deleteorder(order._id)}
                    >
                      <i className="bx bx-trash"></i>
                    </button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      
      </Box>
      <div className="pagination_latestTrend">
      {pagination.totalPages > 1 && (
                        <>
                         
                              <Button disabled={!pagination.hasPrevPage}  onClick={() => handlePageChange(page - 1)}><i className='bx bx-left-arrow-alt' ></i></Button>
                       
                            <span>Page {page} of {pagination.totalPages}</span>
                           
                              <Button  disabled={!pagination.hasNextPage}  onClick={() => handlePageChange(page + 1)}><i className='bx bx-right-arrow-alt'></i></Button>
                        
                        </>
                    )}
                    </div>


                          <Dialog open={editDialogOpen} onClose={closeEditDialog} fullWidth
  maxWidth="md" // Makes the dialog larger than default ('sm')
  PaperProps={{
    sx: { minHeight: "60vh", padding: 2 }, // Optional: increase height and padding
  }}>
        <DialogTitle>Edit Order</DialogTitle>
        <DialogContent dividers>
        <div className="form-row">
           <TextField
            label="Stock Name"
            name="stock_name"
            fullWidth
            margin="dense"
            value={editFormData.stock_name}
            onChange={handleEditChange}
          />
          <TextField
            label="Quantity"
            name="quantity"
            fullWidth
            margin="dense"
            value={editFormData.quantity}
            onChange={handleEditChange}
          />
          <TextField
            label="Entry Price"
            name="entry_price"
            fullWidth
            margin="dense"
            value={editFormData.entry_price}
            onChange={handleEditChange}
          />
        </div>
       <div
  className="form-row"
  style={{
    display: "flex",
    gap: "16px",
    marginBottom: "16px",
    flexWrap: "wrap",
    alignItems: "flex-start",
  }}
>
  {/* Exit Price */}
  <div style={{ flex: 1 }}>
    <TextField
      label="Exit Price"
      name="exit_price"
      fullWidth
      margin="dense"
      value={editFormData.exit_price}
      onChange={handleEditChange}
    />
  </div>

  {/* Order Status */}
  <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
    <label style={{ fontWeight: "bold", marginBottom: "5px" }}>
      Order Status
    </label>
    <select
      value={editFormData.order_status}
      onChange={(e) =>
        setEditFormData({
          ...editFormData,
          order_status: e.target.value,
        })
      }
      style={{
        width: "100%",
        padding: "8px",
        borderRadius: "5px",
        border: "1px solid #ccc",
      }}
    >
      <option value="" disabled>
        Select Status
      </option>
      {statusOptions
        .filter((opt) => opt.value !== "")
        .map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
    </select>
  </div>
</div>

<div
  className="form-row"
  style={{
    display: "flex",
    gap: "16px",
    marginBottom: "16px",
    flexWrap: "wrap",
    alignItems: "flex-start",
  }}
>

  {/* Order Type */}
  <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
    <label style={{ fontWeight: "bold", marginBottom: "5px" }}>Order Type</label>
    <select
      name="type"
      value={editFormData.type}
      onChange={(e) =>
        setEditFormData({ ...editFormData, type: e.target.value })
      }
      style={{
        width: "100%",
        padding: "8px",
        borderRadius: "5px",
        border: "1px solid #ccc",
      }}
    >
      <option value="select" disabled>
        Select Type
      </option>
      <option value="buy">Buy</option>
      <option value="sell">Sell</option>
    </select>
  </div>
</div>
        <div className="createorder_tab-container">
          <div className="createorder_tabs">
            <button
              type="button"
              className={`createorder_tab ${
                selectedTab === "profit" ? "active" : ""
              }`}
              onClick={() => handleTabChange("profit")}
            >
              Profit
            </button>
            <button
              type="button"
              className={`createorder_tab ${
                selectedTab === "loss" ? "active" : ""
              }`}
              onClick={() => handleTabChange("loss")}
            >
              Loss
            </button>
          </div>
          <div className="createorder_tab-content">
            <label>
              Enter Amount for {selectedTab === "profit" ? "Profit" : "Loss"}
              <input
                type="number"
                name="amount"
                value={editFormData.amount}
                onChange={(e)=>{
                  setEditFormData({ ...editFormData, amount: e.target.value })
                }}
                onWheel={(e) => e.target.blur()}
                placeholder={`Enter ${
                  selectedTab === "profit" ? "Profit" : "Loss"
                } Amount`}
              />
            </label>
          </div>
        </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeEditDialog}>Cancel</Button>
          <Button onClick={handleEditSave} variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  );
}
